import { render } from "./CentralReferral.vue?vue&type=template&id=e096de80&ts=true"
import script from "./CentralReferral.ts?vue&type=script&lang=ts&external"
export * from "./CentralReferral.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__